import { Check, Circle } from "lucide-react";
import { PASSWORD_RULES } from "lib/validation";

export function PasswordChecklist({ password, id }: { password: string; id: string }) {
	return (
		<ul
			id={id}
			aria-label="Password requirements"
			className="mt-2 grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-2"
		>
			{PASSWORD_RULES.map(rule => {
				const met = rule.test(password);
				return (
					<li
						key={rule.id}
						data-met={met}
						className={`flex items-center gap-1.5 text-sm ${met ? "text-success" : "text-muted-foreground"}`}
					>
						{met ? (
							<Check
								aria-hidden
								className="size-3.5 shrink-0"
							/>
						) : (
							<Circle
								aria-hidden
								className="size-3 shrink-0"
							/>
						)}
						<span>
							{rule.label}
							<span className="sr-only">{met ? " (met)" : " (not met)"}</span>
						</span>
					</li>
				);
			})}
		</ul>
	);
}
